import * as S from './styled';
import { processText } from '../../../../utils';

export const WhatsNewBlock = ({ t }) => {
  const processedText = processText(t('app_release_notes'));
  return (
    <S.WhatsNewContainer>
      <S.WhatsNewRow>
        <S.Text>{t('version')} 5.64</S.Text>
        <S.Text>{t('updated_ago')}</S.Text>
      </S.WhatsNewRow>
      <S.WhatsNewText dangerouslySetInnerHTML={{ __html: processedText }} />
    </S.WhatsNewContainer>
  );
};
